var _linearGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.002 512.002",
    height: 512,
    viewBox: "0 0 512.002 512.002",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.001,
    x2: 256.001,
    y1: 421.002,
    y2: 91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffde00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m505.698 153.779c-5.046-3.591-11.779-3.712-16.95-.304l-86.097 56.732c-6.946 4.576-8.841 13.94-4.22 20.858 4.952 7.413 7.569 16.035 7.569 24.936 0 24.813-20.187 45-45 45s-45-20.187-45-45c0-14.588 7.198-28.346 19.256-36.803 6.778-4.754 8.423-14.1 3.675-20.883l-70.642-100.917c-2.807-4.01-7.394-6.398-12.288-6.398s-9.481 2.388-12.288 6.398l-70.642 100.916c-4.748 6.782-3.104 16.128 3.675 20.882 12.057 8.457 19.255 22.215 19.255 36.803 0 24.813-20.187 45-45 45s-45-20.187-45-45c0-8.901 2.617-17.523 7.569-24.936 4.62-6.917 2.727-16.281-4.22-20.858l-86.097-56.732c-5.171-3.407-11.906-3.286-16.95.304-5.046 3.591-7.366 9.914-5.841 15.916l61 240c1.922 7.558 9.31 12.382 17.004 11.101 117.803-19.634 237.266-19.634 355.068 0 7.705 1.284 15.087-3.557 17.004-11.101l61-240c1.527-6-.794-12.323-5.84-15.914zm-80.858 235.24c-56.058-8.634-112.444-12.949-168.839-12.949s-112.781 4.315-168.839 12.949l-48.087-189.192 42.438 27.963c-3.63 8.908-5.512 18.458-5.512 28.21 0 41.355 33.645 75 75 75s75-33.645 75-75c0-19.302-7.52-37.715-20.621-51.526l50.621-72.317 50.622 72.317c-13.103 13.812-20.622 32.224-20.622 51.527 0 41.355 33.645 75 75 75s75-33.645 75-75c0-9.752-1.882-19.302-5.512-28.21l42.438-27.963z",
    fill: "url(#SVGID_1_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.77235d75.svg";
export { ForwardRef as ReactComponent };